ACC.delivery = {
  bindall: function() {
    var validationSuccess = false;

    $('.ph-deliveryzipcodeparent__change').click(function() {
      $.getJSON($('.getShippingZipCodesUrl').text(), function(data) {
        if (data.length > 2) {
          $('.ph-deliveryzipcodeparent__popup').addClass('ph-deliveryzipcodeparent__popup--scroll');
        }

        var valOneTime = $('.oneTimeAdress').text();

        if (valOneTime !== '' && valOneTime === 'true') {
          var text = '<div class="ph-deliverypostalcode"><p class="hidden postalerrormsg1">' + $('.errortext1').text() +
           '</p><p class="hidden postalerrormsg2">' + $('.errortext2').text() + '</p><p class="hidden postalerrormsg3">' +
           $('.errortext3').text() + '</p><p class="hidden postalerrormsg4">' + $('.errortext4').text() +
            '</p><input class="ph-deliveryinput" type="textbox" placeholder="Postal Code">' +
            '<button type="button" class="ph-deliverypostalbutton">Update</button></div><div class="ph-deliverylistadd">';

          for (var i in data) {
            if ({}.hasOwnProperty.call(data, i)) {
              text = text + '<span class="ph-deliverylistaddspan"><ul><li>' +
               data[i].companyName + '</li><li>' + data[i].town + '</li><li>' +
               data[i].line1 + '</li><li>' + data[i].postalCode + '</li></ul></span><span class="ph-deliverylistaddbtn">' +
               '<button class="ph-deliverylistbtn" onclick="javascript:setShippingAddr(' + data[i].id + ');" value="' +
               data[i].id + '" data-zipcode="' + data[i].postalCode + '">' + $('.ph-deliveryzipcodeparent__usethisaddress').text() +
               '</button></span><br>';
            }
          }

          text = text + '</div>';
          $('.ph-deliveryzipcodeparent__popup').html(text);
        } else {
          var textClass = '<div class="ph-deliverylistadd">';

          for (var j in data) {
            if ({}.hasOwnProperty.call(data, j)) {
              textClass = textClass + '<span class="ph-deliverylistaddspan"><ul><li>' +
               data[j].companyName + '</li><li>' + data[j].town + '</li>\n' +
              '<li>' + data[j].line1 + '</li><li>' + data[j].postalCode +
               '</li></ul></span><span class="ph-deliverylistaddbtn">\n' +
              '<button class="ph-deliverylistbtn" onclick="javascript:setShippingAddr(' + data[j].id + ');" value="' +
               data[j].id + '" data-zipcode="' + data[j].postalCode + '">' +
               $('.ph-deliveryzipcodeparent__usethisaddress').text() + '</button></span><br>';
            }
          }

          textClass = textClass + '</div>';
          $('.ph-deliveryzipcodeparent__popup').html(textClass);
        }

        $('.ph-deliveryzipcodeparent__popup').toggle();
      });
    });

    function validate(res, error) {
      if (res === false) {
        error.show();
      } else {
        error.hide();
        validationSuccess = true;
      }
    }

    $(document).on('click', '.ph-deliverypostalbutton', function() {
      var storeid = $('.localeid').text().split('-')[2].toUpperCase(),
          str = $.trim($('.ph-deliveryinput').val()),
          res = '',
          patt = '';

      switch (storeid) {
          case 'FR':
          case 'DE':
          case 'US':
            patt = new RegExp('(^\\d{5}$)');
            res = patt.test(str);
            validate(res, $('.postalerrormsg1'));

            break;

          case 'GB':
            patt = new RegExp('^([A-Z0-9]{2,4})[ ][0-9A-Z]{3}$');
            res = patt.test(str);
            validate(res, $('.postalerrormsg2'));

            break;

          case 'SG':
          case 'IN':
            patt = new RegExp('(^\\d{6}$)');
            res = patt.test(str);
            validate(res, $('.postalerrormsg3'));

            break;

          case 'NL':
            patt = new RegExp('\\d{4}[ ][A-Z]{2}');
            res = patt.test(str);
            validate(res, $('.postalerrormsg4'));

            break;
          default:
            break;
      }

      if (validationSuccess) {
        var updatedValue = $('.ph-deliveryinput').val();

        $('.ph-inputloc').val(updatedValue);
        $.ajax({
          url: $('.updateZipCode').text(),
          data: {
            postalCode: updatedValue
          },
          type: 'POST',
          datatype: 'json',
          success: function(result) {
            if (result === true) {
              window.location.reload();
              ACC.delivery.analyticalUpdate(str, ':update');
            }
          }
        });
      }
    });
    $(document).on('click', '.ph-deliverylistbtn', function() {
      var zipcode = $.trim($(this).attr('data-zipcode'));

      ACC.delivery.analyticalUpdate(zipcode, '');
    });
  },
  analyticalUpdate: function(zipcode, isUpdate) {
    ACC.omniture.bindTrackConversion('interaction', 'ship_to:address:' + zipcode.replace(/[^a-zA-Z0-9-.]/g, '') + isUpdate);
  }
};

$(document).ready(function() {
  ACC.delivery.bindall();
});

/* eslint-disable  no-implicit-globals */
/* eslint-disable  no-unused-vars */
function setShippingAddr(zipAddress) {
/* eslint-enable  no-implicit-globals */
/* eslint-enable  no-unused-vars */
  $.getJSON($('.getShippingZipCodesUrl').text(), function() {
    var selectedZipcode = zipAddress;

    $.ajax({
      url: $('.setShippingZipCodesUrl').text(),
      data: {
        shippingAddressID: selectedZipcode
      },
      type: 'POST',
      datatype: 'json',
      success: function(result) {
        if (result === true) {
          window.location.reload();
        }
      },
      error: function(xht, textStatus, ex) {
        if (textStatus === 'error' || textStatus === 'parsererror' || ex.status === 302) {
          window.location = '/login/checkout';
        }
      }
    });
  });
}

